import React, { useState } from "react";
import { Tabs, Tooltip } from "antd";
import "./ChangeSummaryPanel.css";

const { TabPane } = Tabs;

const InfoIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" />
    <line x1="12" y1="16" x2="12" y2="12" />
    <line x1="12" y1="8" x2="12.01" y2="8" />
  </svg>
);

const CatCell = ({ color, label }) => (
  <div className="csp-cat-cell">
    <span className="csp-cat-dot" style={{ background: color || "#9ca3af" }} />
    <span className="csp-cat-text" title={label}>{label || "—"}</span>
  </div>
);

const StationTable = ({ stations, onSelect, selectedWigosid, direction }) => {
  if (!stations || stations.length === 0) {
    return <div className="csp-empty">No {direction === "degraded" ? "degradations" : "improvements"} found</div>;
  }
  const isDown = direction === "degraded";
  return (
    <>
      <table className="csp-table">
        <colgroup>
          <col style={{ width: 26 }} />
          <col style={{ width: "30%" }} />
          <col style={{ width: "28%" }} />
          <col style={{ width: "28%" }} />
          <col style={{ width: 52 }} />
        </colgroup>
        <thead>
          <tr>
            <th>#</th>
            <th>Station</th>
            <th>P1 Cat</th>
            <th>P2 Cat</th>
            <th>Steps</th>
          </tr>
        </thead>
        <tbody>
          {stations.map((s, i) => {
            const steps = parseInt(s.steps);
            return (
              <tr
                key={s.wigosid || i}
                className={selectedWigosid === s.wigosid ? "csp-row--selected" : ""}
                onClick={() => onSelect && onSelect(s)}
                title={`${s.wigosid} — ${s.country || ""}`}
              >
                <td className="csp-td-rank">{i + 1}</td>
                <td>
                  <div className="csp-td-station">{s.name || s.wigosid}</div>
                  <div className="csp-td-location">{s.country}</div>
                </td>
                <td><CatCell color={s.p1_color} label={s.p1_label} /></td>
                <td><CatCell color={s.p2_color} label={s.p2_label} /></td>
                <td>
                  <span className={`csp-steps-badge ${isDown ? "csp-steps-badge--down" : "csp-steps-badge--up"}`}>
                    {isDown ? `↓ ${Math.abs(steps)}` : `↑ ${steps}`}
                  </span>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <button className="csp-view-all">
        View all {direction === "degraded" ? "degraded" : "improved"} stations →
      </button>
    </>
  );
};

const ChangeSummaryPanel = ({
  topDegraded,
  topImproved,
  loading,
  onStationSelect,
  selectedWigosid,
}) => {
  const [activeTab, setActiveTab] = useState("degraded");

  return (
    <div className="csp-panel">
      <div className="csp-panel__header">
        <div>
          <div className="csp-panel__title">
            Change Summary
            <Tooltip
              title="Lists the top 10 stations with the biggest category changes between P1 and P2. Click a station to locate it on the map."
              placement="bottomLeft"
            >
              <span className="csp-info-trigger"><InfoIcon /></span>
            </Tooltip>
          </div>
          <div className="csp-panel__subtitle">by category steps</div>
        </div>
        <button className="csp-download-btn" title="Download CSV">↓</button>
      </div>

      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        size="small"
        className="csp-tabs"
        tabBarStyle={{ paddingLeft: 8, paddingRight: 8 }}
      >
        <TabPane tab={<span className="csp-tab--degraded">Top Degradations</span>} key="degraded">
          {loading
            ? <div className="csp-empty">Loading…</div>
            : <StationTable stations={topDegraded} onSelect={onStationSelect}
                selectedWigosid={selectedWigosid} direction="degraded" />
          }
        </TabPane>
        <TabPane tab={<span className="csp-tab--improved">Top Improvements</span>} key="improved">
          {loading
            ? <div className="csp-empty">Loading…</div>
            : <StationTable stations={topImproved} onSelect={onStationSelect}
                selectedWigosid={selectedWigosid} direction="improved" />
          }
        </TabPane>
      </Tabs>
    </div>
  );
};

export default ChangeSummaryPanel;
